export const uiClasses = {
  appShell: 'app-shell',

  divider: 'border-t border-zinc-200 dark:border-zinc-800 my-8',
  navLink: 'ui-nav-link landing-nav-link font-medium leading-5',

  sectionCopy: 'text-base/7 text-zinc-500 dark:text-zinc-400',
  bodyMuted: 'text-base/7 text-zinc-500 dark:text-zinc-400',
  metricValue: 'dash-type-metric text-xl/6 font-semibold tracking-[-0.015em] tabular-nums text-zinc-950 dark:text-zinc-50',
  textPrimary: 'dash-type-primary text-zinc-950 dark:text-zinc-100',
  textSecondary: 'dash-type-secondary text-zinc-700 dark:text-zinc-300',
  textMuted: 'dash-type-muted text-zinc-600 dark:text-zinc-400',
  textSubtle: 'dash-type-subtle text-zinc-500 dark:text-zinc-400',
  textFaint: 'dash-type-faint text-zinc-400 dark:text-zinc-500',
  barTrack: 'bg-zinc-200 dark:bg-zinc-700/70',
  barFillNeutral: 'bg-zinc-400 dark:bg-zinc-500',
  trackMarker: 'bg-zinc-900 shadow dark:bg-zinc-100',
  borderMuted: 'border-zinc-300 dark:border-zinc-700',
  bubbleEmphasis: 'border-zinc-900 bg-zinc-900 text-zinc-50 dark:border-zinc-100 dark:bg-zinc-100 dark:text-zinc-950',
  bubbleDefault: 'border-zinc-200 bg-zinc-50 text-zinc-800 dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-100',
  codeSurfaceEmphasis: 'border-zinc-200 bg-zinc-100 text-zinc-900 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-100',
  codeSurfaceDefault: 'border-zinc-300 bg-zinc-50 text-zinc-900 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100',
  iconSurface: 'bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-300',
  iconSurfaceMuted: 'bg-zinc-200 text-zinc-600 dark:bg-zinc-700 dark:text-zinc-300',
  checkToggleIdle: 'border-zinc-300 bg-white dark:border-zinc-600 dark:bg-zinc-900',
  neutralBorder: 'border-zinc-300 dark:border-zinc-600',
  dividerFineBorder: 'border-zinc-950/8 dark:border-zinc-700',
  dividerFineDivide: 'divide-zinc-950/8 dark:divide-zinc-700',
  heroOnDark: 'text-zinc-200',
  dotMuted: 'bg-zinc-300 dark:bg-zinc-600',
  hoverPrimary: 'hover:text-zinc-900 dark:hover:text-zinc-100',
  hoverSecondary: 'hover:text-zinc-600 dark:hover:text-zinc-300',
  linkDecorationMuted: 'decoration-zinc-300 dark:decoration-zinc-600',
  borderTopSoft: 'border-zinc-900/10 dark:border-zinc-700',
}
